import { Popup } from '@approvalmax/ui';
import styled from 'styled-components';

export const StyledPopup = styled(Popup.DefaultContent)`
    position: relative;
    width: 1000px;
`;

export const Root = styled.div`
    position: relative;
    padding: 0 60px 50px 80px;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const LoadingBarContainer = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 8px;
`;
